import React from 'react'
import './Header.css'
import CTA from './CTA'
import ME from '../../assets/me.png'
import HeaderSocials from './HeaderSocials'
import { Typewriter } from 'react-simple-typewriter'



const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <h4 style={{ paddingTop: "32px" }}>Hello I'm</h4>
        <h1>Md. Al Mamun Ridoy</h1>




        <span style={{ color: "#4db5ff", fontSize: "22px", fontWeight: "bold" }}>
          <Typewriter
            words={[
              "Web Developer",
              "React Developer",
              "Front End Developer",
            ]}
            loop={5}
            cursor
            cursorStyle="_"
            typeSpeed={150}
            deleteSpeed={50}
            delaySpeed={1000}
          />
        </span>





        <CTA />
        <HeaderSocials />

        <div className="me">
          <img src={ME} alt="me" />
        </div>

        <a href="#contact" className='scroll__down'>Scroll Down</a>
      </div>
    </header>
  )
}

export default Header